export const baseName = '/svetV2';

export default {
  // HOME: '/',
  // INVESTMENTS: '/investments',
  INVESTMENTS: '/',
  SWAP: '/:mode/:id',
};
